(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dv-custom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dv-custom-paid-order')) {
  customElements.define('dv-custom-paid-order', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const form = this.querySelector('form');
      if (!form) return;
      const size = form.querySelector('[data-custom-size]');
      const agreement = form.querySelector('[data-custom-agree]');
      const file = form.querySelector('[data-custom-file]');
      const button = form.querySelector('[data-custom-submit]');
      const price = form.querySelector('[data-custom-price]');
      const update = () => {
        price.textContent = size.selectedOptions[0]?.dataset.price || '—';
        button.disabled = !agreement.checked || !size.value;
      };
      const validateFile = () => {
        const chosen = file.files[0];
        const valid = !chosen || (/\.(jpe?g|png|tiff?|webp|pdf)$/i.test(chosen.name) && chosen.size <= 20 * 1024 * 1024);
        file.setCustomValidity(valid ? '' : file.dataset.error);
      };
      size.addEventListener('change', update, options);
      agreement.addEventListener('change', update, options);
      file.addEventListener('change', validateFile, options);
      form.addEventListener('submit', event => {
        validateFile();
        if (!form.reportValidity() || !agreement.checked) { event.preventDefault(); return; }
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
      }, options);
      window.addEventListener('pageshow', () => { form.removeAttribute('aria-busy'); update(); }, options);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dv-home"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('dv-product-row')) {
  customElements.define('dv-product-row', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const track = this.querySelector('.dv-product-track');
      const controls = this.querySelector('.dv-row-arrows');
      if (!track || !controls) return;
      controls.hidden = false;
      const buttons = [...controls.querySelectorAll('button')];
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft >= max - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left: Number(button.dataset.step) * track.clientWidth * .9,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal: this.controller.signal}));
      track.addEventListener('scroll', update, {passive: true, signal: this.controller.signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
